import React from 'react'
import styled from 'styled-components'

const ScenarioTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  td {
    border: 1px solid black;
  }
`

export default function Scenario({ introduction, items }) {
  return (
    <div>
      <b>Scenario</b>
      <p>{introduction}</p>
      <ScenarioTable>
        <tbody>
          {items.map((item, i) => (
            <tr key={i}>
              {item.map((text, i) => <td key={i}>{text}</td>)}
            </tr>
          ))}
        </tbody>
      </ScenarioTable>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/AssessmentPlan/Scenario.js